import Vue from 'vue';
import Form from '@@/model/Form';
import Panel from '@@/components/Panel.vue';
import C3Cart from '~/modules/c3/components/C3Cart.vue';
import C3PaymentUi from '~/modules/c3/components/C3PaymentUi.vue';
import jQuery from 'jquery';
import {Collapse} from 'bootstrap';
import util from '~/app/utils';

new Vue({
  el: '#app-sample',
  components : {
    C3Cart,
    C3PaymentUi,
    Panel
  },

  computed: {
    sample() {
      return this.$app.state.sample;
    },
    
    hasItems() {
      return this.items.length > 0;
    },

    grandTotal() {
      return this.totalAmount + this.shippingAmount;
    },

    formSample() {
      if(!this.$data._form) {
        this.$data._form = new Form('sample-form', store.fieldsShippingInfo);
        console.log('form values', store.state.formValues);
        this.$data._form.fields.Country.callback = this.fieldChangeHandler;
        this.$data._form.fields.ShipMethod.callback = this.fieldChangeHandler;
        this.formSample.setValues(store.state.formValues);
        // initial force to set
        this.fieldChangeHandler(this.$data._form.fields.Country);
      }

      return this.$data._form;
    },
    
    // build the transaction object for the payment processors
    transaction() {
      return {
        invoiceId: undefined, //
        description: 'Sample/Swatch Order',
        amount: this.grandTotal,
      }
    }
  },

  data() {
    return {
      collapseAddress: null,
      collapsePayment: null,
      currentState: 'address',
      currentTab: 'collapseAddress',
      paymentData: null,
      isFormValid: false,
      totalAmount: 0,
      shippingAmount: 0,
      items: this.$app.state.items,
      _form: null,
      authorizeNet: this.$app.config['authorizeNet'],
      paypal: this.$app.config['paypal']
    }
  },

  created() {
    // console.log('vuex store:', this.$store.state);
    console.log('app store:', this.$app);
  },

  mounted() {
    console.log('sample mounted with transaction:', this.transaction);
    this.collapseAddress = new Collapse(jQuery('#collapseAddress'), {
      toggle: false
    })
    this.collapsePayment = new Collapse(jQuery('#collapsePayment'), {
      toggle: false 
    })

    if(this.items.length > 0) {
      this.collapseAddress.show()
    }

    util.addScript(this.authorizeNet.script);
  },


  methods: {
    onCountryChanged(e) {
      let el = e.target;
      let val = el.value;
      console.log('country changed: ', val)
      window.countryStateElementDisplay(el)


      let elShipMethod = this.$refs.ShipMethod;
      if(val == 'United States') {
        console.log('united');
        window.populateSelectControl(elShipMethod, this.$app.state.shippingMethods.local)
      } else {
        console.log('other');
        window.populateSelectControl(elShipMethod, this.$app.state.shippingMethods.international)
      }
    },

    onShipChange(el) {
      console.log('ship method changed', el)
      let shipmethod = el.target.value;
      if(!shipmethod) {
        this.shippingAmount = 0;
      } else {
        this.shippingAmount = this.$app.state.shippingPrices[shipmethod] || 0;
      }
    },

    onCartUpdate(cart) {
      this.totalAmount = cart.grandTotal;
    },

    onSampleClick(item, event) {
      document.body.style.cursor = 'wait';
      window.location.href = '/c3/catalog/product/' + item.id;
    },

    onSampleRemove(item, event) {
      document.body.style.cursor = 'wait';
      window.location.href = '/sample/delete?id=' + item.id;
    },

    onShippingEdit() {
      jQuery('#shippingTab').collapse('show');
      jQuery('#paymentTab').collapse('hide');
    },

    onShippingSubmit(e) {
      let form = this.$refs.theForm;
      let valid = false;
      valid = form.checkValidity();
      form.classList.add('was-validated');

      this.isFormValid = valid;
      if(!valid) {
        jQuery('html, body').animate({
              scrollTop: jQuery("#form-sample").offset().top - 10
            }, 500);
      } else {
        this.collapseAddress.hide()
        this.collapsePayment.show()
      }
    },

    validate() {
      try {
        let errors = this.formSample.validate();
        if (!errors) {
          return true;
        }
      } catch (exception) {
        console.log(exception);
      }

      return false;
    },

    updateShippingCost(value) {
      
    },

   

    
    fieldChangeHandler(field) {
      let form = this.formSample;
      console.log('field changer', field);
      if(field.name === 'Country') {
        let fldState = form.fields['State'];
        let fldShipping = form.fields['ShipMethod'];
  
        store.updateCountryStateFields(field, fldState);
        let shippingOptions = store.shippingOptionsForCountry(field.value);
        // fldShipping.value = ''; // reset shipping select value
        fldShipping.data = shippingOptions;
        this.updateShippingCost(fldShipping.value);
      } else if(field.name === 'ShipMethod') {
        this.updateShippingCost(field.value);
      }
    },
    

    onPaypal() {
    },
  
    onPaymentSuccess(data, processor) {
      console.log('payment success', processor, data);
      document.getElementById('PaymentInfo').value = JSON.stringify(data);
      document.getElementById('PaymentType').value = processor;
      let form = document.getElementById('form-sample');
      document.body.style.cursor = 'wait';
      form.submit();
    },
  
    onPaymentError(err, processor) {
      console.log('payment error', processor, err);
      console.log('fail with error:', err );
    }
  }
});
